import { Spinner } from "@npco/zeller-design-system";
import * as Illustration from "@npco/zeller-design-system/illustration";
import { ADT } from "pb.adt";

import { formatCurrency } from "../../../../@lib-i18n/format-currency";
import { Layout } from "../../shared/layout";
import { createOperationPages } from "../../shared/operation-pages";
import { PageTemplate } from "../../shared/page-template";
import { Prompt } from "../../shared/prompt";
import { Page } from "./page";

const defaultLayoutProps = {
	actionsStyle: "full-width",
	logo: true,
} satisfies Layout.Props;

export function render(page: Page) {
	return ADT.switch(page, {
		...createOperationPages("Refund"),
		InitialisingRefund: PageTemplate({
			image: <Spinner size="lg" />,
			title: "Initialising Refund",
			intermediate: true,
		}),
		SignatureSubmitted: ({
			signature,
			onClose,
			onApprove,
			onDecline,
			cancelling,
		}) => (
			<Layout
				{...defaultLayoutProps}
				onClose={onClose}
				pending={cancelling ? "close" : undefined}
				actions={[
					{ label: "Approve", onClick: onApprove, primary: true },
					{ label: "Decline", onClick: onDecline },
				]}
			>
				<Prompt
					image={
						signature ? (
							<img
								alt="customer signature"
								className="dark:invert w-[180px] h-[180px]"
								src={signature}
							/>
						) : (
							<Illustration.TerminalT2Signature loop={false} />
						)
					}
					title="Verify Signature"
				/>
			</Layout>
		),
		// response states
		Approved: ({ currency, totalCents, onDone }) => (
			<Layout
				{...defaultLayoutProps}
				timeout={{ onTimeout: onDone }}
				actions={[{ label: "Done", onClick: onDone, primary: true }]}
			>
				<Prompt
					image={<Spinner size="lg" result="ok" />}
					title={`${formatCurrency({ amountInCents: totalCents, currency })} Approved`}
				/>
			</Layout>
		),
		Declined: ({ title, subtitle, message, onRetry, onCancel }) => (
			<Layout
				{...defaultLayoutProps}
				timeout={{ onTimeout: onCancel }}
				actions={[
					{ label: "Try Again", onClick: onRetry, primary: true },
					{ label: "Cancel", onClick: onCancel },
				]}
			>
				<Prompt
					image={<Spinner size="lg" result="error" />}
					title={title}
					subtitle={subtitle}
					message={message}
				/>
			</Layout>
		),
	});
}
